import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { $profileStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { ApprovePayments, Navigation, TransferRequests, Recipients } from './widgets';
import { PageContainer } from '@widgets';
import { UserType } from '@shared/api';

export const PaymentsPage = () => {
  const profileStore = useUnit($profileStore.store);

  const { t } = useTranslation('payments');

  return (
    <PageContainer title={t('title')} header={t('header')}>
      <div className='flex flex-col gap-6'>
        <div
          className={cn(
            'flex flex-col gap-5',
            PaletteUtils.isVcfcPalette && 'gap-9 rounded-xl bg-white p-6 dark:rounded-xl dark:border dark:border-gray-black dark:bg-soft-black',
          )}
        >
          <Navigation />
          {profileStore.data?.userType !== UserType.User && <ApprovePayments />}
        </div>
        <Recipients />
        <TransferRequests />
      </div>
    </PageContainer>
  );
};
